import { render, staticRenderFns } from "./VehicleCard.vue?vue&type=template&id=7c64746a&scoped=true"
import script from "./VehicleCard.vue?vue&type=script&lang=js"
export * from "./VehicleCard.vue?vue&type=script&lang=js"
import style0 from "./VehicleCard.vue?vue&type=style&index=0&id=7c64746a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c64746a",
  null
  
)

export default component.exports